import React from 'react';
import MemberTemp from '../components/MemberTemp';
import MemberForm from '../components/MemberForm';
const Join = () => {
    return (
        <MemberTemp>
            <MemberForm type="join" />
        </MemberTemp>
    );
};

export default Join;